export type RequirementPaymentMethod = 'BankTransfer' | 'DirectDebit' | 'Sipo';

export const RequirementPaymentMethod = {
    BankTransfer: 'BankTransfer' as RequirementPaymentMethod,
    DirectDebit: 'DirectDebit' as RequirementPaymentMethod,
    Sipo: 'Sipo' as RequirementPaymentMethod
};
